import { Component, Inject } from '@angular/core';
import { SharedService } from '../../../shared/services/shared.service';
import { LoaderService } from '../../../shared/services/loader.service';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonComponent, TextInputComponent } from 'ddmo-storybook-lib';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'app-edit-profile-admin',
  imports: [
    CommonModule,
    MatDialogModule,
    ButtonComponent,
    TextInputComponent,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule
  ],
  templateUrl: './edit-profile-admin.component.html',
  styleUrl: './edit-profile-admin.component.scss'
})
export class EditProfileAdminComponent {
  mainError = '';
  isUpdated:boolean = false;
  payload:any
  public profileForm = new FormGroup({
    userName: new FormControl('', [
      Validators.required,
      Validators.maxLength(50),
      this.sharedService.noWhitespaceValidator(),
    ])
  });

  constructor(
    private sharedService: SharedService,
    private loader: LoaderService,
    private dialogRef: MatDialogRef<EditProfileAdminComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router
  ) {}

  ngOnInit() { 
    if(this.data){
      this.profileForm.patchValue({
        userName : this.data?.userName
      })
    }

  }

  updateProfile(){
    this.profileForm.markAllAsTouched();
    const formValue = this.profileForm.getRawValue();
    if (this.profileForm.controls['userName'].invalid || formValue.userName?.trim() === this.data?.userName) return;
    this.loader.show();
    this.mainError = '';
    const userId = this.data?.userId;
    this.payload = {
      userId:userId?Number(userId):0,
      userName: formValue.userName?.trim(),
      admin: true
    };
    this.sharedService.updateAuth0User(this.payload).subscribe({
      next: (res) => {
        this.loader.hide();
        this.isUpdated = true;
      },
      error: (err) => {
        this.loader.hide();
        const message = err?.error?.message || '';
        this.mainError = message;
        this.sharedService.logError("APIFailed", "FileEdit-profileComponent - updateAuth0User, Method:updateProfile", this.router.url.split('?')[0], err).subscribe();
      },
    });
  }

  closeDialog(){
    this.dialogRef.close(this.payload);
  }

}
